export const DELIVERY_TYPES = {
    MEEST_BRANCH: "MeestBranch",
    NOVA_POSHTA_BRANCH: "NovaPoshta",
   
};